;(function () {
  var memory = {
    lastClickedFilterId: null,
  };


  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return (root || document).querySelectorAll(sel); }

  function closest(el, selector) {
    while (el && el.nodeType === 1) {
      if (el.matches ? el.matches(selector) :
          el.msMatchesSelector ? el.msMatchesSelector(selector) :
          el.webkitMatchesSelector ? el.webkitMatchesSelector(selector) :
          false) {
        return el;
      }
      el = el.parentNode;
    }
    return null;
  }

  function parseConfig() {
    var configRawData = qs("[data-bab-steps-config]");
    if (!configRawData) return null;
    try {
      return JSON.parse(configRawData.textContent || configRawData.innerText || "");
    } catch (e) {
      console.warn("Invalid BAB steps config JSON", e);
      return null;
    }
  }

  function getJuoFilterButtons() {
    return qsa(".box-builder__filters button.filter-item[data-filter-id]");
  }

  function findJuoButtonById(id) {
    return qs('.box-builder__filters button.filter-item[data-filter-id="' + id + '"]');
  }

  function hideJuoFiltersUI() {
    var juoFilters = qs(".box-builder__filters");
    if (juoFilters) juoFilters.style.display = "none";
  }

  function clickJuoFilterBtn( colId ) {
      var juoBtn = findJuoButtonById(colId);
      if (juoBtn && colId !== memory.lastClickedFilterId ) { 
        juoBtn.click();
        memory.lastClickedFilterId = colId;
      }
  }


  function showStepCollections(stepId) {
    var stepLis = qsa('button[data-bab-step-tab][data-step-id]');
    for (var i = 0; i < stepLis.length; i++) {
      var stepBtn = stepLis[i];
      var li = closest(stepBtn, "li");
      if (!li) continue;

     
      var nestedUl = qs("ul", li);
      if (!nestedUl) continue;

      if (stepBtn.getAttribute("data-step-id") === stepId) {
        nestedUl.style.display = "";
        stepBtn.setAttribute("aria-current", "true");
      } else {
        nestedUl.style.display = "none";
        stepBtn.removeAttribute("aria-current");
      }
    }
  }



  // Override JUO's inline grid calculation with our responsive columns
  function getDesiredCols() {
    var w = window.innerWidth;
    if (w >= 1450) return 'repeat(auto-fill, minmax(min(350px, 100%), 1fr))';
    if (w >= 1100) return 'repeat(4, 1fr)';
    if (w >= 750)  return 'repeat(3, 1fr)';
    return 'repeat(2, 1fr)';
  }

  function enforceProductGrid() {
    var list = qs('.box-builder__products-list');
    if (!list) return;
    var cols = getDesiredCols();
    // Only write if JUO has changed it, to avoid triggering our own observer
    if (list.style.getPropertyValue('grid-template-columns') !== cols) {
      list.style.setProperty('grid-template-columns', cols, 'important');
    }
  }

  function watchProductGrid() {
    var list = qs('.box-builder__products-list');
    if (!list || typeof MutationObserver === 'undefined') return;
    var gridObs = new MutationObserver(enforceProductGrid);
    gridObs.observe(list, { attributes: true, attributeFilter: ['style'] });
  }

  function clickFirstCollectionInStep(stepId) {
    var stepBtn = qs('button[data-bab-step-tab][data-step-id="' + stepId + '"]');
    if (!stepBtn) return;

    var li = closest(stepBtn, "li");
    if (!li) return;

    var firstCollectionBtn = qs('button[data-collection-id]', li);
    if (!firstCollectionBtn) return;

    var colId = firstCollectionBtn.getAttribute("data-collection-id");
    if (!colId) return;

    clickJuoFilterBtn( colId );

    // var juoBtn = findJuoButtonById(colId);
    // if (juoBtn) juoBtn.click();
  }

  function initJuoSteps() {
    var config = parseConfig();
    if (!config) return;

    // Wait until JUO buttons exist.... clicking dependency
    function isJuoReady() {
      return getJuoFilterButtons().length > 0;
    }

    function initOnceReady() {
      hideJuoFiltersUI();

      // Default: first step button in your markup
      var firstStepBtn = qs('button[data-bab-step-tab][data-step-id]');
      var defaultStepId = firstStepBtn ? firstStepBtn.getAttribute("data-step-id") : null;

      // if (config.defaultStepId) {
      //   var exists = qs('button[data-bab-step-tab][data-step-id="' + config.defaultStepId + '"]');
      //   if (exists) defaultStepId = config.defaultStepId;
      // } 

      // Event delegation for step clicks and collection clicks
      document.addEventListener("click", function (e) {
        var t = e.target;

        // Step button click
        var stepBtn = closest(t, "button[data-bab-step-tab][data-step-id]");
        if (stepBtn) {
          var topLevelParent  = '.hs-juo-top-level-item';
          var isActiveClass   = 'hs-is-active-item';
          var stepId          = stepBtn.getAttribute("data-step-id");

          if (!stepId) return;

          var allTopItems = qsa(topLevelParent);
          for (var i = 0; i < allTopItems.length; i++) {
            allTopItems[i].classList.remove(isActiveClass);
          }

          var parentLi = closest(stepBtn, topLevelParent);
          if (parentLi) {
            parentLi.classList.add(isActiveClass);
          }

         // showStepCollections(stepId);
          clickFirstCollectionInStep(stepId);
          return;
        }

        var colBtn = closest(t, "button[data-collection-id]");
        if (colBtn) {
          var colId = colBtn.getAttribute("data-collection-id");
          if (!colId) return;

          clickJuoFilterBtn(colId);
          //  var juoBtn = findJuoButtonById(colId);
          // if (juoBtn) juoBtn.click(); 

          // add active state on mirror buttons
          var allMirror = qsa("button[data-collection-id]");
          for (var i = 0; i < allMirror.length; i++) {
            allMirror[i].removeAttribute("aria-pressed");
          }
          colBtn.setAttribute("aria-pressed", "true");
        }


      });

      // Auto-activate step 1 AFTER the listener is registered so it gets handled
      if (defaultStepId) {
        var defaultStepBtn = qs('button[data-bab-step-tab][data-step-id="' + defaultStepId + '"]');
        if (defaultStepBtn) defaultStepBtn.click();
      }

      // Apply responsive grid columns, watch for JUO overrides, and keep in sync on resize
      //enforceProductGrid();
      //watchProductGrid();
      //window.addEventListener('resize', enforceProductGrid);
    }

    // If JUO is already there, init immediately; otherwise observe.
    if (isJuoReady()) {
      initOnceReady();
      return;
    }

    if (typeof MutationObserver === "undefined") {
      // Fallback polling
      var tries = 0, maxTries = 80; // ~8s at 100ms
      var timer = setInterval(function () {
        tries++;
        if (isJuoReady()) {
          clearInterval(timer);
          initOnceReady();
        } else if (tries >= maxTries) {
          clearInterval(timer);
        }
      }, 100);
      return;
    }

    var obs = new MutationObserver(function () {
      if (isJuoReady()) {
        obs.disconnect();
        initOnceReady();
      }
    });

    obs.observe(document.documentElement, { childList: true, subtree: true });
  }

  document.addEventListener("DOMContentLoaded", initJuoSteps);
})();